export interface Action {
  type: ActionType
  payload?: any
}

export enum ActionType {
  'INIT' = 'INIT',
  'SAVED_REFCODE' = 'SAVED_REFCODE',
  'SAVED_USER_INFO' = 'SAVED_USER_INFO',
  'PDPA_SUBMITTED' = 'PDPA_SUBMMITED',
  'SAVED_KYC_CONTEXT_TYPE' = 'SAVED_KYC_CONTEXT_TYPE',
}
